import { reflect } from '@effector/reflect';
import { Trash2 } from 'lucide-react';
import { equals, not } from 'patronum';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { USER_ROLES } from 'shared/api';
import { ConfirmModalProps, createConfirmModal } from 'shared/ui';
import { DeleteBonusModel } from '../../model';

export const createDeleteBonusModal = (model: DeleteBonusModel) => {
	const ConfirmModal = createConfirmModal(model);

	const DeleteBonusModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		return (
			<ConfirmModal
				ref={ref}
				title={t('delete-bonus.title')}
				cancelButtonProps={{
					children: t('delete-bonus.cancel'),
				}}
				submitButtonProps={{
					children: t('delete-bonus.delete'),
					variant: 'destructive',
				}}
				{...props}
			>
				{t('delete-bonus.description')}
			</ConfirmModal>
		);
	});

	const DeleteBonusModalActionIcon = reflect({
		view: ConfirmModal.ActionIcon,
		bind: {
			'data-test-id': 'delete-bonus-action-icon',
			variant: 'ghost-destructive',
			disabled: not(equals(viewerModel.$role, USER_ROLES.god)),
			children: <Trash2 />,
		},
	});

	return Object.assign(DeleteBonusModal, {
		ActionIcon: DeleteBonusModalActionIcon,
	});
};
